import Dashboard from './containers/DashboardContainer';
import getPlayers from '../../modules/players/actions/getPlayers';
import getGames from '../../modules/games/actions/getGames';

export default store => ({
  path: 'home',
  component: Dashboard,
  onEnter() {
    getPlayers()(store.dispatch, store.getState);
    getGames()(store.dispatch, store.getState);
  }
});



// WEBPACK FOOTER //
// ./src/routes/home/index.js